/**
 * Namespaces Mastra `resource` IDs per agent so memory (message history,
 * semantic recall, working memory, etc.) never merges across agents that share
 * the same storage backend.
 */
export const toMastraResourceId = (
    agentId: string,
    baseResourceId: string,
): string => {
    const prefix = `${agentId}:`;
    if (baseResourceId.startsWith(prefix)) {
        return baseResourceId;
    }

    return `${prefix}${baseResourceId}`;
};

/** Strips the agent namespace added by {@link toMastraResourceId}. */
export const getBaseResourceId = (
    mastraResourceId: string,
    agentId: string,
): string => {
    const prefix = `${agentId}:`;
    if (mastraResourceId.startsWith(prefix)) {
        return mastraResourceId.slice(prefix.length);
    }

    return mastraResourceId;
};
